module.exports = __webpack_public_path__ + "static/app-store-dark-666400f4ab1c57e46dce10c1e559303c.svg";